"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var HeadphoneDisconnectAudioNo = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_HeadphoneDisconnectAudioNo_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5V13a1 1 0 0 0 1 1 2.5 2.5 0 0 0 2.5-2.5v-1A2.5 2.5 0 0 0 13.5 8v-.5a5.5 5.5 0 1 0-11 0V8A2.5 2.5 0 0 0 0 10.5v1A2.5 2.5 0 0 0 2.5 14a1 1 0 0 0 1-1V7.5a4.5 4.5 0 0 1 9 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.147 13.854a.5.5 0 0 1 0-.708L7.293 11 5.147 8.854a.5.5 0 1 1 .707-.708L8 10.293l2.146-2.147a.5.5 0 1 1 .708.708L8.707 11l2.147 2.146a.5.5 0 0 1-.707.708L8 11.707l-2.146 2.147a.5.5 0 0 1-.707 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_HeadphoneDisconnectAudioNo_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = HeadphoneDisconnectAudioNo;
exports["default"] = _default;